export default "__VITE_ASSET__qH1ulOlD__"